import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {FieldStyle} from './../../styles'

export default class Field extends Component {
  state = {
    value: '',
    patternEmail: '',
  }

  componentDidMount() {
    const { value } = this.props
    if (value && (value !== '' || typeof value !== 'undefined')) this.changeValue(value)
  }

  componentWillReceiveProps({clean}) {
    if (clean !== this.props.clean) {
      this.setState({ value: '' })
    }
  }

  handleChange = (event) => {
    this.changeValue(event.target.value)
  }

  changeValue = (val) => {
    this.setState({value: val})
    if (typeof this.props.onChange === 'function') this.props.onChange({key: this.props.name, value: val})
  }

  iEmail = (email) => {
    // Test pattern Email
  }

  static defaultProps = {
    big: false,
  }

  render() {
    const { children, id, type, name, className, big, disabled} = this.props
    return(
      <div className={ `form-field ${FieldStyle(this.state.value === '', big)}` }>
        <input type={type} id={id} name={name} value={this.state.value} ref={(input) => this.input = input} className={className} onChange={this.handleChange} disabled={disabled} />
        {
          type !== 'hidden' && (
            <label htmlFor={id}>{ children }</label>
          )
        }
      </div>
    )
  }
}

Field.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
  big: PropTypes.bool,
}


// WEBPACK FOOTER //
// ./src/components/Form/Field.js